import script from "./FamousView.vue?vue&type=script&lang=ts&setup=true"
export * from "./FamousView.vue?vue&type=script&lang=ts&setup=true"

import "./FamousView.vue?vue&type=style&index=0&id=a3c23a86&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3c23a86"]])

export default __exports__